import { FACE_BY_ID } from "~/lib/faces";
import { useFaceSeo } from "~/lib/seo/useSeo";
import {
  CATEGORY_LABELS,
  CATEGORY_ORDER,
  TIMELINE,
  groupByCategory,
  type Milestone,
} from "~/lib/build/timeline";

export function Build() {
  const face = FACE_BY_ID.build;
  useFaceSeo(face);
  const porCategoria = groupByCategory(TIMELINE);

  return (
    <section className="jg-shell pb-24 pt-12 sm:pt-16">
      <p className="jg-eyebrow">Trabalho</p>

      <h1 className="mt-5 max-w-[16ch] font-display text-[clamp(2rem,5.5vw,3.2rem)] font-medium leading-[1.08] tracking-[-0.02em]">
        Dez anos, e dá para conferir cada um.
      </h1>

      <p className="mt-6 max-w-[58ch] text-[length:var(--text-step-0)] leading-[1.55] text-jg-fg-muted">
        João Vidotto, engenheiro mobile sênior, em Londrina. Trabalho entre
        aplicativo nativo e tecnologia imersiva: Unity, Unreal, Android com
        Kotlin, React Native, realidade aumentada e, agora, bastante
        integração com modelos de linguagem — inclusive neste site.
      </p>

      {CATEGORY_ORDER.map((cat) => {
        const itens = porCategoria[cat];
        if (itens.length === 0) return null;
        return (
          <section key={cat} className="mt-16">
            <h2 className="jg-eyebrow border-t border-jg-rule pt-5">
              {CATEGORY_LABELS[cat]}
            </h2>
            <ul>
              {itens.map((m) => (
                <li key={m.id} className="border-t border-jg-border py-7">
                  <Marco marco={m} />
                </li>
              ))}
            </ul>
          </section>
        );
      })}

      <p className="mt-16 border-t border-jg-rule pt-8 text-sm text-jg-fg-muted">
        Precisa de alguém para construir alguma dessas coisas?{" "}
        <a className="jg-link" href="/hire">
          Me conte o problema
        </a>
        .
      </p>
    </section>
  );
}

function Marco({ marco }: { marco: Milestone }) {
  const titulo = marco.link ? (
    <a
      className="underline decoration-jg-border decoration-1 underline-offset-[6px] transition-[text-decoration-color] duration-150 hover:decoration-jg-accent"
      href={marco.link}
      target="_blank"
      rel="noopener noreferrer"
    >
      {marco.title} <span aria-hidden="true">↗</span>
    </a>
  ) : (
    marco.title
  );

  return (
    <article className="jg-grid">
      <p className="jg-eyebrow col-span-full tabular-nums lg:col-span-2 lg:pt-1.5">
        {marco.year ?? "—"}
      </p>

      <div className="col-span-full mt-2 lg:col-span-7 lg:mt-0">
        <h3 className="font-display text-[length:var(--text-step-1)] font-medium leading-snug">
          {titulo}
        </h3>
        <p className="mt-3 max-w-[58ch] leading-relaxed text-jg-fg-muted">
          {marco.body}
        </p>
      </div>

      {marco.tags && marco.tags.length > 0 && (
        <p className="col-span-full mt-3 text-sm text-jg-fg-muted lg:col-span-3 lg:mt-0 lg:pt-1.5">
          {marco.tags.join(" · ")}
        </p>
      )}
    </article>
  );
}
